import { Transaction } from "../../../domain/types/Transaction";

export const exportTransactionsToCSV = async (
  transactions: Transaction[],
): Promise<void> => {
  const headers = [
    "Date",
    "Description",
    "Category",
    "Amount",
    "Type",
    // "Account",
    "Merchant",
    // "Status",
  ];

  const rows = transactions.map((transaction) => [
    new Date(transaction.transaction_date).toLocaleDateString(),
    transaction.merchant_name || transaction.transaction_details?.name || "",
    transaction.category_description || "",
    transaction.amount.toString(),
    transaction.transaction_type,
    // transaction.account_name,
    transaction.merchant_name || "",
    // transaction.status,
  ]);

  const csvContent = [
    headers.join(","),
    ...rows.map((row) => row.join(",")),
  ].join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  const fileName = `transactions-${new Date().toISOString()}.csv`;
  link.setAttribute("href", url);
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
